import React from 'react';

import NewsletterList from '../../../components/Admin/Newsletter';

function NewsletterListView() {
  return (
    <NewsletterList />
  );
}

export default NewsletterListView; 